export default __webpack_public_path__ + "static/media/03_photo.30da6a01.jpg";